var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slideshow"},[_c('flickity',{ref:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l((_vm.images),function(path,index){return _c('div',{staticClass:"slide w-100"},[_c('img',{staticClass:"img-fluid",attrs:{"src":path}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }